module.exports = __webpack_public_path__ + "img/level-3.4e39e696.svg";